// extracted by mini-css-extract-plugin
module.exports = {"section":"Contact_section__GRC0g","badge":"Contact_badge__VWzC5","boxEmail":"Contact_boxEmail__sF4p6","contact":"Contact_contact__TgWOW"};